export type SubscriptionPlan = 'free' | 'pro';
export type SubscriptionStatus = 'active' | 'expired' | 'cancelled' | 'grace_period';

export interface Subscription {
  id: string;
  userId: string;
  plan: SubscriptionPlan;
  status: SubscriptionStatus;
  platform?: string;
  revenuecatId?: string;
  currentPeriodStart?: Date;
  currentPeriodEnd?: Date;
}
